// Single source of truth for the checkout link.
//
// There is ONE product: full access, billed from day one, no trial.
// EUR 11.49 / USD 13.49 / GBP 9.99 per month (multi-currency price, Stripe
// picks the currency from the buyer). Success URL is
// /success?session_id={CHECKOUT_SESSION_ID}.
//
// Hardcoded on purpose: this used to read VITE_STRIPE_LIVE_PAYMENT_LINK, and a
// stale value of that variable silently sold the app for EUR 6.49 with no trial
// framing anywhere in the UI. No env override, no fallback chain, one constant.
// If the link ever changes, change it here and nowhere else.
export const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/6oU14n0xHflDeo69aTbMQ08';

// Headline prices shown next to the link above. Kept here so the paywall and
// the funnel paywall cannot drift apart.
export const CURRENCY_OPTIONS = {
  EUR: { symbol: '€', price: '11.49', billed: '€11.49' },
  USD: { symbol: '$', price: '13.49', billed: '$13.49' },
  GBP: { symbol: '£', price: '9.99',  billed: '£9.99'  },
};
